import { QFF_LOGIN_BUNDLE_URL } from 'config';
import { loadScript } from 'lib/script';

const loadQffAuthScript = () => loadScript({ url: QFF_LOGIN_BUNDLE_URL });

export default loadQffAuthScript;
